import { render, staticRenderFns } from "./FriendRecommend.vue?vue&type=template&id=465e9d76&scoped=true"
import script from "./FriendRecommend.vue?vue&type=script&lang=js"
export * from "./FriendRecommend.vue?vue&type=script&lang=js"
import style0 from "./FriendRecommend.vue?vue&type=style&index=0&id=465e9d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465e9d76",
  null
  
)

export default component.exports